import { curry2 } from '@most/prelude';
import { HoldSubjectSource } from '../sources';
export var hold = curry2(function hold(bufferSize, subject) {
    return new subject.constructor(new HoldSubjectSource(subject.source, bufferSize));
});
//# sourceMappingURL=hold.js.map


//////////////////
// WEBPACK FOOTER
// ./~/most-subject/lib/es2015/combinators/hold.js
// module id = 1596
// module chunks = 0